import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { TABLE__empty } from '@/pages/_base/table/TABLE__empty';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { useTranslation } from 'react-i18next';
import { WTableUserInvitationsRow } from './WTableUserInvitationsRow';

export function WTableUserInvitations() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { workspace_current, invitations_map_to_other_users } = use_slice_workspace(['workspace_current', 'invitations_map_to_other_users']);

  function render_items() {
    let invitations = Array.from(invitations_map_to_other_users.values())
      .sort(DTO__database_entity.sort_by_created_at_newest_first)
      .filter(item => item.workspace_id == workspace_current._id)
      .filter(item => item.target_user_email != CONSTANTS__shared.TOKEN_WORKSPACE_INVITATION_LINK_EMAIL);

    if (invitations.length === 0) return <TABLE__empty />;

    return invitations.map(item => <WTableUserInvitationsRow key={item._id} item={item} />);
  }

  if (workspace_current.is_personal) return <></>;

  return (
    <div
      className={`${md(
        'h-[350px] min-h-[350px] w-full',
        ' max-h-[30vh] pt-2',
      )} mt-3  flex flex-col justify-center items-start  border-b border-component-border  text-page-foreground`}
    >
      <div className="text-xl">{t(i18n_page_settings_workspace.tabs.users.shared.table.user_invitation.title)}</div>
      <div
        className={`${md(
          ' px-2 justify-between',
          'gap-5 px-5 justify-start',
        )} border-b border-component-border  w-full min-h-[50px] flex flex-row items-center    mt-2`}
      >
        <span className={`${md('w-[45px] text-[10px]', 'w-[100px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.users.shared.table.user_invitation.column.status)}
        </span>
        <span className={`${md('w-[45px] text-[10px]', 'w-[280px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.users.shared.table.user_invitation.column.email)}
        </span>
        <span className={`${md('w-[45px] text-[10px]', 'w-[160px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.users.shared.table.user_invitation.column.sent_at)}
        </span>
        <span className={`${md('w-[45px] text-[10px]', 'w-[120px]')}  text-center`}>
          {t(i18n_page_settings_workspace.tabs.users.shared.table.user_invitation.column.actions)}
        </span>
      </div>
      <div className="flex flex-col justify-start items-center h-full w-full overflow-auto">{render_items()}</div>
    </div>
  );
}
